import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-extension-input',
  templateUrl: './extension-input.component.html',
  styleUrl: './extension-input.component.scss'
})
export class ExtensionInputComponent {
  @Input() extensions: string[] = [];
  @Output() extensionsChange: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  currentInput: string = '';
  showError: boolean = false;

  constructor() { }

  onEnter(value: string): void {
    if (!value) return;

    const trimmedValue = value.trim();


    if (trimmedValue.includes('.')) {
      this.showError = true;
      return;
    }


    this.showError = false;

    if (!this.extensions.includes(trimmedValue)) {
      this.extensions.push(trimmedValue);
    }

    this.currentInput = '';
    this.extensionsChange.emit(this.extensions);
  }

  removeExtension(index: number): void {
    this.extensions.splice(index, 1);
    this.extensionsChange.emit(this.extensions);
  }
}
